export default {
        traveling_by: [
        {
            value: 'PLANE',
            label: 'Letecky',
            icon: 'img/trip/66a8f50a728e8915ee938382_letecky.svg',
        },
        {
            value: 'BUS',
            label: 'Autobusom',
            icon: 'img/trip/66a8f508d1b5bf34001f7d1c_autobus.svg',
        }
    ],
    storno_type: [
        {
            value: 'ADDON',
            label: 'Chcem sa pripoistiť',
            icon: 'img/trip/MONEY.png',
        },
        {
            value: 'NONE',
            label: 'Nechcem sa pripoistiť',

            icon: 'img/trip/682db332b1706becc05e9bb5_image001.png',
        },

        // {
        //     value: 'SEPARATE',
        //     label: 'Samostatne',
        //     icon: 'img/trip/682db332b1706becc05e9bb5_image001.png',
        // },
    ],
    travel_reason: [
        {
            value: 'VACATION',
            label: 'Dovolenka',
            icon: 'img/trip/66a8f508f002185641a9eb89_dovolenka.svg',
        },
        {
            value: 'CONCERT',
            label: 'Koncert',
            icon: 'img/trip/66a8f508522b280c9e067fc7_koncert.svg',
        },
        {
            value: 'FESTIVAL',
            label: 'Festival',
            icon: 'img/trip/66a8f5089e66f3ddb649b754_festival.svg',
        },
        {
            value: 'SPORTS',
            label: 'Šport',
            icon: 'img/trip/66a8f50928bcc82649b7a5dc_sport.svg',
        },
        {
            value: 'WORK',
            label: 'Práca',
            icon: 'img/trip/66a8f5092c6c4b637f3479bb_praca.svg',
        },
        {
            value: 'STUDY',
            label: 'Štúdium',
            icon: 'img/trip/66a8f50a5c32eaf43823f0d5_svet.svg',
        },
        {
            value: 'SKI_TRIP',
            label: 'Lyžovačka',
            icon: 'img/trip/66a8f50a92a565dc954631ed_lyzovacka.svg',
        },
    ],
    regional_coverage: [
        {
            value: 'EUROPE',
            label: 'Európa',
            icon: 'img/trip/66a8f508778f4567aaf05e8f_europa.svg',
        },
        {
            value: 'WORLD',
            label: 'Svet',
            icon: 'img/trip/66a8f680cc05720da883eb88_8planeta.png',
        },
        {
            travelReasons: [
                'CONCERT', 'FESTIVAL'
            ],
            value: 'SLOVAKIA',
            label: 'Slovensko',
            icon: 'img/trip/66a8f509190b793431723a24_slovensko.svg',
        },
    ],
    age_above_70: [
        {
            value: false,
            label: 'Nie<br /><small>cestujúci mladší<br /> ako 70 rokov</small>',
            icon: 'img/trip/TravelAsset 50.svg',
        },
        {
            value: true,
            label: 'Áno<br /><small>cestujúci starší<br />ako 69 rokov</small>',
            icon: 'img/trip/TravelAsset 49.svg',
        }
    ]
}